export const breadcrumbsItems = [
  {
    title: 'Администрация',
  },
  {
    title: 'Медкомплексы',
    href: '/medcomplex',
  },
  // {
  //   title: 'Новый медкомплекс',
  // },
]
